import Store from 'lightningjs-redux';

import {
  getElapsedTimeInSeconds,
  getLBannerProvider,
  getAdvertising,
  getLBannerState,
  isAdMode,
  getAdMarkers,
} from '../../../logic/player/player.selectors';

const mapControllers = instance => [
  {
    selector: getElapsedTimeInSeconds,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.elapsed = value;
    },
  },
  {
    selector: getLBannerProvider,
    callback: value => {
      instance.provider = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getAdvertising,
    callback: value => {
      instance.advertising = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getLBannerState,
    callback: value => {
      instance.lBannerState = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: isAdMode,
    callback: value => {
      instance.isPlayingAds = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getAdMarkers,
    callback: value => {
      instance.adMarkers = value || [];
    },
    shouldBeInvokedOnConnect: true,
  },
];

export default Store.control(mapControllers);
